import $ from 'jquery';

class Navigation {
  constructor() {
    this.headerOnScroll();
    this.navDropdown();
    this.mobileNavToggler();
  }

  headerOnScroll() {
    this.body = document.body;
    this.header = $('.js-header');
    this.headerCopy = this.header
      .clone()
      .prependTo(this.body)
      .hide()
      .css({
        position: 'fixed',
        'z-index': 999,
        opacity: 0,
      });

    let position = $(window).scrollTop();

    this.navCopy = this.headerCopy
      .find('.js-nav')
      .find('ul')
      .first();
    this.togglerCopy = this.headerCopy.find('.js-nav-toggler');
    this.toggler = this.header.not(this.headerCopy).find('.js-nav-toggler');

    $(window).on('scroll', () => {
      const scrollingPosition = $(window).scrollTop();
      const scrollingDirection = scrollingPosition > position ? 'down' : 'up';

      if (scrollingDirection === 'up' && position > this.header.height() * 2) {
        this.headerCopy
          .show()
          .stop()
          .animate(
            {
              opacity: 1,
            },
            100,
          );

        if (this.toggler.hasClass('is-active')) {
          this.toggler.trigger('click');
        }
      } else {
        this.headerCopy.stop().animate(
          {
            opacity: 0,
          },
          100,
          () => {
            if (this.togglerCopy.hasClass('is-active')) {
              this.togglerCopy.trigger('click');
            }
            this.headerCopy.hide();
          },
        );
      }

      position = scrollingPosition;
    });
  }

  navDropdown() {
    this.nav = $('.js-nav');
    this.dropdownParent = this.nav.find('.js-menu-item-has-children');

    if (this.dropdownParent.length) {
      this.dropdownParent.on('click', 'a', e => {
        e.preventDefault();
        const self = $(e.currentTarget);
        const dropdown = self.next('.js-nav-dropdown');

        if (dropdown.hasClass('is-open')) {
          dropdown.removeClass('is-open');
        } else {
          dropdown.addClass('is-open');
        }
      });
    }
  }

  mobileNavToggler() {
    this.navToggler = $('.js-nav-toggler');

    if (this.navToggler.length) {
      this.navToggler.on('click', e => {
        const toggler = $(e.currentTarget);
        const target = toggler.data('target');
        const nav = toggler.parent().find(`#${target}`);

        toggler
          .toggleClass('is-active')
          .attr('aria-expanded', toggler.hasClass('is-active'));

        if (nav.length) {
          if (nav.is(':visible')) {
            nav.css({ display: 'block' });
          }
          nav.slideToggle(400, () => {
            if (nav.is(':visible')) {
              nav.css({ display: 'flex' });
            } else {
              nav.css({ display: '' });
            }
          });
        }
      });
    }
  }
}

export default new Navigation();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js